"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var chevron_right_1 = require("adp-react-icons/lib/fa/chevron-right");
var SubMenuItem = /** @class */ (function (_super) {
    __extends(SubMenuItem, _super);
    function SubMenuItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnClick = function () {
            var _a = _this.props, onClick = _a.onClick, config = _a.config;
            if (onClick) {
                onClick(config);
            }
        };
        return _this;
    }
    SubMenuItem.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, config = _b.config, active = _b.active;
        var submenuItemClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item')] = true,
            _a[vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item--active')] = active,
            _a);
        return (React.createElement("li", { className: classnames_1.classNames(className, submenuItemClasses), onClick: this.handleOnClick },
            active &&
                React.createElement(chevron_right_1.default, { className: vdl_prefix_1.vdlPrefix('mega-menu-popover__submenu-item__active_indicator') }),
            config.title));
    };
    SubMenuItem.propTypes = {
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        config: PropTypes.object.isRequired,
        active: PropTypes.bool
    };
    return SubMenuItem;
}(React.Component));
exports.SubMenuItem = SubMenuItem;
